import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  skypointProspectsLoading: false,
  skypointProspects: [],
  skypointProspectsStatus: [],
  skypointProspectsFiltersCount: {},
  skypointProspectsCount: 0,
  skypointProspectsTotalCount: 0,
};

export const skypointProspect = createSlice({
  name: "skypointProspect",
  initialState,
  reducers: {
    setSkypointProspectsLoading(state, action) {
      return {
        ...state,
        skypointProspectsLoading: action?.payload,
      };
    },
    setSkypointProspects(state, action) {
      return {
        ...state,
        skypointProspectsLoading: false,
        skypointProspects: action?.payload?.prospects,
        skypointProspectsFiltersCount: action?.payload?.statusCounts,
        skypointProspectsCount: action?.payload?.count,
        skypointProspectsTotalCount: action?.payload?.totalCount,
      };
    },
    setSkypointProspectsStatus(state, action) {
      return {
        ...state,
        skypointProspectsLoading: false,
        skypointProspectsStatus: action?.payload?.statuses,
      };
    },
  },
});

export const {
  setSkypointProspectsLoading,
  setSkypointProspects,
  setSkypointProspectsStatus,
} = skypointProspect.actions;
export default skypointProspect.reducer;
